export default __webpack_public_path__ + "static/media/egg_video04.e17cc21f.jpg";